const alertNameMapping: Record<string, string> = {
  // Gerados pelo H2
  '3311': '70% água',
  '3111': '100% água',

  // Alarmes Técnicos
  '3121': 'Solenoide aberta, vazão = 0 (pulsos negativos)',
  '3122': 'Solenoide fechada, vazão > 0 (pulsos positivos)',
  '3231': 'H2 perdeu a conexão com a central',
  '3131': 'H2 desconectado do chicote',
  '2136': 'Central desconectada',

  // Gerados pela Central
  '2211': 'Falta mistura',
  '2112': 'Redosagem',
  '2311': 'Tempo 1h30',
  '2111': 'Tempo 2h30',

  // Alarmes Técnicos
  '2131': 'H2 perdeu a conexão',
  '2132': 'ST perdeu a conexão (STCA)',
  '2133': 'Central reiniciou, erro aleatório',
  '2134': 'Central reiniciou, BLE 63',
  '2135': 'Central reiniciou, BLE 61',
  '2123': 'Parafuso faltando',
  '2124': 'Sensor de pressão de ar com problema',
  '2125': 'Sensor de pressão de óleo com problema',

  // Gerados pelo Hermes
  '1131': 'Hermes desconectado',
  '1132': 'Problema na comunicação da Central com o Hermes',
  '1133': 'Problema na comunicação do H2 com o Hermes',
  '1134': 'Hermes reiniciou',
  '1135': 'Hermes perdeu o IP',
  '1136': 'Remessa recusada, está fora da central',
  '1137': 'Quectel não responde AT por 30 minutos',
};

export default alertNameMapping;
